import React from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import AppRoutes from './routes/AppRoutes'
import { AuthProvider } from './context/AuthContext'
import AnimatedBackground from './components/ui/AnimatedBackground'
import TitleBar from './components/layout/TitleBar'

// Der Partikel-Hintergrund gehoert zur Trainer-App. Auf dem Arcade-Portal laeuft
// parallel ein Spiel im iframe — dort kostet eine zweite Dauer-Animation nur
// Akkulaufzeit und Frames, besonders auf dem Handy.
function BackgroundLayer() {
  const { pathname } = useLocation();
  if (!pathname.startsWith('/app')) return null;
  return <AnimatedBackground />;
}

function App() {
  const [isElectron, setIsElectron] = React.useState(false);

  React.useEffect(() => {
    if (window.navigator.userAgent.includes('Electron')) {
      setIsElectron(true);
    }
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <TitleBar />
        <BackgroundLayer />
        <div className={isElectron ? "pt-10 min-h-screen w-full" : "min-h-screen w-full"}>
          <AppRoutes />
        </div>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
